import React from 'react'
import styles from './DropdownAnchor.module.scss'

interface DropdownAnchorProps {
  children: React.ReactNode
  className?: never
}

export const DropdownAnchor = React.forwardRef<HTMLDivElement, DropdownAnchorProps>(
  ({ children }, ref) => (
    <div ref={ref} className={styles.anchor}>
      {children}
    </div>
  ),
)

DropdownAnchor.displayName = 'DropdownAnchor'
